import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import ElementUI from 'element-ui';
import qs from 'qs'
import httpPlugin from '@/utils/http'
import {Message} from 'element-ui'
import '@/assets/style/reset.css';
import '@/assets/style/common.less';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/theme/index.css'
// 动态生成表单
import FormMaking from 'form-making'
import 'form-making/dist/FormMaking.css'
import BaiduMap from 'vue-baidu-map'
import echarts from 'echarts'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(httpPlugin)
Vue.use(FormMaking)
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'nkqax6Zg7styTQtvL3lOjtXPooERYHFW'
})
Vue.use(require('vue-moment'));

Vue.prototype.$qs = qs
Vue.prototype.$echarts = echarts

// 导航守卫
router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth === false) {
        next()
        return
    }
    let token = store.state.token
    if (!from.name && token) next()
    else if (from.name && token && to.name === 'login') router.go(-1)

    if (!token && to.path !== '/login') next({path: '/login'})
    else next()

    let userInfo = store.state.userInfo
    if (!userInfo) return;
    let time = new Date().getTime() - userInfo.loginTime;

    if (time > userInfo.expires_in * 1000) {
        Message.error('登录超时,请重新登录');
        sessionStorage.clear();
        store.commit('DEL_TOKEN');
        next({path: '/login'});
    }

})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
